<template>
<div ref="subGlobal" class="global-main global-shadow">

  <!-- ---------------------- 索引表格 ---------------------- -->
  
  <div class='global-panel' v-loading.body="loading.main">
    <div class='global-header'>
      <div class='global-title'>系统机构</div>
      <div class='global-tbar'>
        <el-button size="small" type="default" @click="findByCondition()">检索</el-button>
      </div>
    </div>
    <hr>
    <div class='global-body'>
      <el-row>
        <el-col :span="12">
          <div>
            <div class='global-title'>
              <span>机构职位列表</span>
              <el-button size="mini" round type="primary" style="margin-left:50px" @click="insert">新增机构</el-button>
              <el-button size="mini" round type="default" @click="$refs.systemOrganTable.setCurrentRow()">取消选中</el-button>
              <el-button size="mini" round type="success" style="margin-left:50px" @click="editPost">加入职位</el-button>
            </div>
            <div ref="organTable" style="overflow:scroll;width:100%">
              <el-table ref="systemOrganTable" :data="systemOrgans" border stripe style="width: 100%" size="mini"
                        default-expand-all row-key="treeId" :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                        highlight-current-row @current-change="handleOrganChange">
                <el-table-column prop="orgName" label="名称" min-width="200">
                  <template slot-scope="scope">
                    <i v-show="scope.row.orgType=='机构'" style="color:#E6A23C" class="el-icon-s-home"></i>
                    <i v-show="scope.row.orgType=='职位'" style="color:#67C23A" class="el-icon-s-check"></i>
                    <span>{{scope.row.orgName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="orgType" label="类型" width="100">
                  <template slot-scope="scope">
                    <span v-show="scope.row.orgType=='机构'" style="color:#E6A23C">{{scope.row.orgType}}</span>
                    <span v-show="scope.row.orgType=='职位'" style="color:#67C23A">{{scope.row.orgType}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="displayOrder" label="排序" width="100"></el-table-column>
                <el-table-column prop="note" label="备注" width="140" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                  <template slot-scope="scope">
                    <el-button v-show="scope.row.orgType=='机构'" class="global-text-btn-success" size="mini" type="text" @click="insertSubOrgan(scope.row.id, scope.row.orgFullName)">新增子机构</el-button>
                    <el-button v-show="scope.row.orgType=='机构'" size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
                    <el-button v-show="scope.row.orgType=='机构'" class="global-text-btn-danger" size="mini" type="text" @click="remove(scope.row)" style="margin-left: 10px;">删除</el-button>
                    <el-button v-show="scope.row.orgType=='职位'" class="global-text-btn-danger" size="mini" type="text" @click="removePost(scope.row)" style="margin-left: 10px;">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <div class='global-title'>
              <span>职位用户列表</span>
              <el-button size="mini" round type="primary" style="margin-left:50px" @click="editUser">加入用户</el-button>
            </div>
            <div ref="postUserTable" style="overflow:scroll;width:100%">
              <el-table :data="postUserList" border stripe style="width:100%;" size="mini">
                <el-table-column prop="loginName" label="登录名"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                  <template slot-scope="scope">
                    <el-button class="global-text-btn-danger" size="mini" type="text" @click="removeUser(scope.row)" style="margin-left: 10px;">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>
  
  <!-- ---------------------- 编辑弹窗 ---------------------- -->
  
  <el-dialog :visible.sync="visible.editDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.editDialog">
      <el-form ref="form" :model="editSystemOrgan" :rules="rules" label-width="70px" size="small">
        <el-form-item label="父机构" prop="parentName">
          <el-input v-model="editSystemOrgan.parentName" readonly></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="orgName">
          <el-input v-model="editSystemOrgan.orgName"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="displayOrder">
          <el-input v-model="editSystemOrgan.displayOrder"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="editSystemOrgan.note"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button size="small" type="primary" @click="save" style="width: 220px;margin-left: 60px">保存</el-button>
        <el-button size="small" type="default" @click="visible.editDialog=false">取消</el-button>
      </div>
    </div>
  </el-dialog>

  <el-dialog :visible.sync="visible.postDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.postDialog">
      <div class='global-title' style="width:100%">
        <el-button size="mini" round type="primary" @click="addPost"><i class="el-icon-back"></i></el-button>
        <el-input size="mini" placeholder="过滤条件" style="width:50%;line-height:20px;" v-model="condition.postName"></el-input>
        <el-button size="mini" type="default" @click="findPostByCondition()">检索</el-button>
      </div>
      <div ref="organPostDiv" style="overflow:scroll;width:100%">
        <el-table :data="postList" border stripe style="width:100%;" size="mini"
                  @selection-change="postSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="postName" label="名称"></el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>

  <el-dialog :visible.sync="visible.userDialog" width="600px" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="loading.userDialog">
      <div class='global-title' style="width:100%">
        <el-button size="mini" round type="primary" @click="addUser"><i class="el-icon-back"></i></el-button>
        <el-input size="mini" placeholder="过滤条件" style="width:50%;line-height:20px;" v-model="condition.userName"></el-input>
        <el-button size="mini" type="default" @click="findUserByCondition()">检索</el-button>
      </div>
      <div ref="organUserDiv" style="overflow:scroll;width:100%">
        <div class="global-paging" v-show="userPaging.allNum > userPaging.everySize" >
          <el-pagination layout="prev, pager, next" @current-change="findUserByCondition(arguments[0])" :current-page="userPaging.currPage" :page-size="userPaging.everySize" :total="userPaging.allNum"></el-pagination>
        </div>
        <el-table :data="userList" border stripe style="width:100%;" size="mini" @selection-change="userSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="loginName" label="登录名"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
        </el-table>
        <div class="global-paging" v-show="userPaging.allNum > userPaging.everySize" >
          <el-pagination layout="prev, pager, next" @current-change="findUserByCondition(arguments[0])" :current-page="userPaging.currPage" :page-size="userPaging.everySize" :total="userPaging.allNum"></el-pagination>
        </div>
      </div>
    </div>
  </el-dialog>
  
</div>
</template>

<script>

export default {
  name: 'SystemOrganIndex',
  data () {
    return {
      // 系统机构列表
      systemOrgans: [],
      // 职位列表
      postList: [],
      postSelection: [],
      // 用户列表
      userList: [],
      userSelection: [],
      // 职位用户列表
      postUserList: [],
      // 遮罩
      loading: {main: false, editDialog: false, postDialog:false, userDialog:false},
      // 可见
      visible: {editDialog: false, postDialog:false, userDialog:false},
      // 条件
      condition:{},
      // 系统机构
      selectionSystemOrgan: {},
      editSystemOrgan: {},
      // 校验规则
      rules: {
        orgName: [
          { required: true, message: '该项必填', trigger: 'change' },
          { max: 50, message: '长度最多50个字符', trigger: 'change' }
        ],
        displayOrder: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        note: [
          { max: 200, message: '长度最多200个字符', trigger: 'change' }
        ]
      },
      // 分页
      userPaging: {currPage: 1, everySize: 15, allNum: 0}
    }
  },
  
  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.height = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
    vm.$refs.organTable.style.height = (window.innerHeight-vm.$baize.frameTitleHeight-130)+'px';
    vm.$refs.postUserTable.style.height = (window.innerHeight-vm.$baize.frameTitleHeight-130)+'px';
    vm.findByCondition();
  },
  
  methods: {
    /*
     * 查询所有
     */
    findByCondition: function () {
      let vm = this;
      // 开启遮罩
      vm.loading.main = true;
      var params = vm.condition
      // 请求后台
      vm.$http.get('rest/sys/systemOrgan/findByCondition', {params: params}).then(response => {
        vm.systemOrgans = response.body.systemOrgans;
        vm.selectionSystemOrgan = {};
        vm.editSystemOrgan = {};
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    editPost: function () {
      let vm = this;
      if(vm.selectionSystemOrgan.orgType != "机构"){
        vm.$alert('未选择机构，或选择的节点不是机构', '提示', {type:'error'});
        return;
      }
      // 开启遮罩
      vm.visible.postDialog = true;
      vm.findPostByCondition();
    },
    editUser: function () {
      let vm = this;
      if(vm.selectionSystemOrgan.orgType != "职位"){
        vm.$alert('未选择职位，或选择的节点不是职位', '提示', {type:'error'});
        return;
      }
      // 开启遮罩
      vm.visible.userDialog = true;
      vm.findUserByCondition();
    },
    /*
     * 查询职位
     */
    findPostByCondition: function () {
      let vm = this;
      // 开启遮罩
      vm.loading.postDialog = true;
      let params = vm.condition
      // 请求后台
      vm.$http.get('rest/sys/systemOrgan/findPostByCondition', {params: params}).then(response => {
        vm.postList = response.body.postList;
        vm.postSelection = [];
        // 关闭遮罩
        vm.loading.postDialog = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.postDialog = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    /*
     * 查询用户
     */
    findUserByCondition: function (currentPage) {
      let vm = this;
      if(currentPage){
        vm.userPaging.currPage = currentPage;
      } else {
        vm.userPaging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      let params = vm.condition;
      params.currPage = vm.userPaging.currPage;
      params.everySize = vm.userPaging.everySize;
      // 请求后台
      vm.$http.get('rest/sys/systemOrgan/findUserByCondition', {params: params}).then(response => {
        vm.userList = response.body.userList;
        vm.userPaging = response.body.pagingBean;
        vm.userSelection = [];
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    handleOrganChange: function (val) {
      var vm = this
      if(val!=null){
        vm.selectionSystemOrgan = val;
      } else {
        vm.selectionSystemOrgan = {};
      }
      if(vm.selectionSystemOrgan.orgType == '职位'){
        // 请求后台
        vm.$http.get('rest/sys/systemOrgan/findUserByPost/'+vm.selectionSystemOrgan.organId+"/"+vm.selectionSystemOrgan.id).then(response => {
          vm.postUserList = response.body.postUserList;
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
        }, response => {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      } else {
        vm.postUserList = [];
      }
    },
    /*
     * 新增
     */
    insert: function () {
      var vm = this
      vm.visible.editDialog = true
      vm.editSystemOrgan = {}
    },
    /*
     * 新增子机构
     */
    insertSubOrgan: function (parentId, parentName) {
      var vm = this
      vm.visible.editDialog = true
      vm.editSystemOrgan = {parentId:parentId, parentName:parentName, displayOrder:0}
    },
    /*
     * 编辑
     */
    edit: function (record) {
      var vm = this
      vm.visible.editDialog = true
      vm.editSystemOrgan = JSON.parse(JSON.stringify(record));
    },
    
    /*
     * 删除
     */
    remove: function (record) {
      var vm = this;
      vm.$confirm('确定要删除[' + record.orgName + ']吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.delete('rest/sys/systemOrgan/removeOrg/'+String(record.id)).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition()
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    /*
     * 删除职位
     */
    removePost: function (record) {
      var vm = this;
      vm.$confirm('确定要删除[' + record.orgName + ']吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.delete('rest/sys/systemOrgan/removePost/'+String(record.organId)+'/'+String(record.id)).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition();
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    /*
     * 删除用户
     */
    removeUser: function (record) {
      var vm = this;
      vm.$confirm('确定要删除[' + record.name+'('+record.loginName+')' + ']吗？', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.delete('rest/sys/systemOrgan/removeUser/'+String(vm.selectionSystemOrgan.organId)+'/'+String(vm.selectionSystemOrgan.id)+'/'+String(record.id)).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.handleOrganChange(vm.selectionSystemOrgan);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    /*
     * 保存
     */
    save: function () {
      var vm = this;
      // 校验
      vm.$refs['form'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['form'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.editDialog = true;
        // 调用后台
        vm.$http.post('rest/sys/systemOrgan/saveData', vm.editSystemOrgan).then(function (response) {
          vm.editSystemOrgan = response.body;
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          // 关闭弹窗并重新查询
          vm.visible.editDialog = false
          vm.findByCondition()
        }, response => {
          // 关闭遮罩
          vm.loading.editDialog = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      });
    },
    /*
     * 增加职位
     */
    addPost: function () {
      let vm = this;
      // 开启遮罩
      vm.loading.main = true;
      let param ={};
      param.organId = vm.selectionSystemOrgan.id;
      param.postSelection = vm.postSelection;
      // 调用后台
      vm.$http.post('rest/sys/systemOrgan/addPost', param).then(function (response) {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
        // 关闭弹窗并重新查询
        vm.visible.postDialog = false;
        vm.findByCondition();
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    },
    /*
     * 增加用户
     */
    addUser: function () {
      let vm = this;
      // 开启遮罩
      vm.loading.userDialog = true;
      let param ={};
      param.organId = vm.selectionSystemOrgan.organId;
      param.positionId = vm.selectionSystemOrgan.id;
      param.userSelection = vm.userSelection;
      // 调用后台
      vm.$http.post('rest/sys/systemOrgan/addUser', param).then(function (response) {
        // 关闭遮罩
        vm.loading.userDialog = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
        // 关闭弹窗并重新查询
        vm.visible.userDialog = false;
        vm.handleOrganChange(vm.selectionSystemOrgan);
      }, response => {
        // 关闭遮罩
        vm.loading.userDialog = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    },
    postSelectionChange(val) {
      this.postSelection = val;
    }
    ,
    userSelectionChange(val) {
      this.userSelection = val;
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/system/systemorgan/SystemOrganIndex.vue